const $progressBar = $('.page-loading .progress-bar');

// listenImagesLoading(
//   $('img, body'),
//   mainFunc,
//   function(per, instance) {
//     $progressBar.css({ width: per + '%' });
//   }
// );

var loadAni = new TimelineMax({ paused: true});
loadAni
.to('.loadingLeft', 1.4, { left:"-100%"}, '+=0')
.to('.loadingRight', 1.4, { right:"-100%",onComplete:function(){
  $('.page-loading').remove();
}}, '-=1.4')

var kvAni= new TimelineMax({ paused: true});
kvAni
.from('.kv .kvTitle', 0.5, { y:-50, opacity: 0, ease: Power2.easeOut }, '+=2.5')
.from('.kv .kvSlogan', 0.5, { y:-50, opacity: 0, ease: Power2.easeOut }, '+=0')

var coverkvAni= new TimelineMax({ paused: true});
coverkvAni
.fromTo('#coverKv', 1, { scale:0.5, opacity: 0},{scale:1, opacity:1, ease: Back.easeOut }, '+=1')

var secAni1_1 = new TimelineMax({ paused: true});
    secAni1_1
    .from('.sec-1 .box1 .aniTxt', 0.4, { y:-50, opacity: 0, ease: Power2.easeOut }, '+=0.5')
    .from('.sec-1 .box1 .ani1', 0.4, { x:-40, opacity: 0, ease: Back.easeOut }, '-=0')
    .from('.sec-1 .box1 .ani2', 0.4, { x:-40, opacity: 0, ease: Back.easeOut }, '-=0.2')
    .from('.sec-1 .box1 .ani3', 0.4, { x:-40, opacity: 0, ease: Back.easeOut }, '-=0.2')
    .from('.sec-1 .box1 .ani4', 0.4, { y:-20, opacity: 0, ease: Back.easeOut }, '-=0.2')
    .from('.sec-1 .box1 .source', 0.4, { opacity: 0, ease: Power2.easeOut }, '-=0.2')

var secAni1_2 = new TimelineMax({ paused: true});
    secAni1_2
    .from('.sec-1 .box2 .aniTxt', 0.4, { opacity: 0, y:-50, ease: Power2.easeOut }, '+=0.5')
    .from('.sec-1 .box2 .ani1', 0.4, { opacity: 0, y:40, ease: Back.easeOut }, '-=0')
    .from('.sec-1 .box2 .ani2', 1, { opacity: 0, x:-200, y:50, scale:0, ease: Power4.easeInOut }, '-=0')
    .from('.sec-1 .box2 .source', 0.4, { opacity: 0, ease: Power2.easeOut }, '-=0.2')

var secAni2_1 = new TimelineMax({ paused: true});
    secAni2_1
    .from('.sec-2 .box1 .aniTxt', 0.4, { opacity: 0, y:-50, ease: Power2.easeOut }, '+=0.5')
    .from('.sec-2 .box1 .chartBox', 0.5, { opacity: 0, scale: 0.5,rotation: 20, ease: Back.easeOut }, '+=0')
    .staggerFrom('.sec-2 .box1 .coBlock', 0.3, { opacity: 0, y:40, ease: Power2.easeOut },0.1 , '-=0.2')
    .from('.sec-2 .box1 .source', 0.4, { opacity: 0, ease: Power2.easeOut }, '-=0')

var secAni2_2 = new TimelineMax({ paused: true});
    secAni2_2
    .from('.sec-2 .box2 .aniTxt', 0.4, { opacity: 0, y:-50, ease: Power2.easeOut }, '+=0.5')
    .from('.sec-2 .box2 .ani1', 0.5, { opacity: 0, scale:0.9, ease: Back.easeOut }, '+=0')
    .from('.sec-2 .box2 .ani2', 0.5, { opacity: 0, y:-50, x:-50, ease: Back.easeOut }, '-=0.4')
    .from('.sec-2 .box2 .ani3', 0.5, { opacity: 0, y:50, x:-50, ease: Back.easeOut }, '-=0.4')
    .from('.sec-2 .box2 .ani4', 0.5, { opacity: 0, y:-50, x:50, ease: Back.easeOut }, '-=0.4')
    .from('.sec-2 .box2 .ani5', 0.5, { opacity: 0, y:50, x:50, ease: Back.easeOut }, '-=0.4')
    .from('.sec-2 .box2 .source', 0.4, { opacity: 0, ease: Power2.easeOut }, '-=0')

var secAni3_1 = new TimelineMax({ paused: true});
    secAni3_1
    .from('.sec-3 .box1 .ani1', 0.5, { opacity: 0, y: 50, ease: Power2.easeOut }, '+=0.5')
    .from('.sec-3 .box1 .ani2', 0.5, { opacity: 0, y: 50, ease: Power4.easeOut }, '+=0')
    .from('.sec-3 .box1 .ani3', 0.5, { opacity: 0,x:-30, y: 30, scale:0.5, ease: Back.easeOut }, '+=0')
    .from('.sec-3 .box1 .source', 0.4, { opacity: 0, ease: Power2.easeOut }, '-=0')

var secAni3_2 = new TimelineMax({ paused: true});
    secAni3_2
    .from('.sec-3 .box2 .ani1', 0.5, { opacity: 0, y: 50, ease: Power2.easeOut }, '+=0.5')
    .from('.sec-3 .box2 .ani2', 0.5, { opacity: 0, y: 50, ease: Power4.easeOut }, '+=0')
    .from('.sec-3 .box2 .ani3', 0.5, { opacity: 0, y: 50, ease: Back.easeOut }, '+=0')
    .from('.sec-3 .box2 .source', 0.4, { opacity: 0, ease: Power2.easeOut }, '-=0')

var secAni4 = new TimelineMax({ paused: true});
    secAni4
    .from('.sec-4 .aniTxt', 0.4, { y:-50, opacity: 0, ease: Power2.easeOut }, '+=0.5')
    .from('.sec-4 .source', 0.4, { opacity: 0, ease: Power2.easeOut }, '-=0')
    .from('.sec-4 .ani1', 0.4, { x:-20, opacity: 0, ease: Back.easeOut }, '-=0')
    .from('.sec-4 .ani2', 0.5, { x:-20, scale:1.5, opacity: 0, ease: Back.easeOut }, '-=0')

var secAni5_1 = new TimelineMax({ paused: true});
    secAni5_1
      .from('.sec-5 .box1 .aniTxt', 0.4, { opacity: 0, y:-50, ease: Power2.easeOut }, '+=0.5')
      .from('.sec-5 .box1 .chart1 .ani1', 0.4, { opacity: 0, y:-50, ease: Back.easeOut }, '+=0')
      .from('.sec-5 .box1 .chart1 .source', 0.4, { opacity: 0, ease: Power2.easeOut }, '+=0')
      .from('.sec-5 .box1 .chart2 .ani2', 0.4, { opacity: 0, y:-50, ease: Back.easeOut }, '+=0')
      .from('.sec-5 .box1 .chart2 .ani3', 0.4, { opacity: 0, y:50, ease: Back.easeOut }, '+=0')
      .from('.sec-5 .box1 .chart2 .source', 0.4, { opacity: 0, ease: Power2.easeOut }, '+=0')

var secAni5_2 = new TimelineMax({ paused: true});
    secAni5_2
    .from('.sec-5 .box2 .aniTxt', 0.4, { opacity: 0, y:-50, ease: Power2.easeOut }, '+=0.5')
    .from('.sec-5 .box2 .ani1', 0.3, { opacity: 0, y:40, ease: Back.easeOut }, '+=0')
    .from('.sec-5 .box2 .ani2', 0.3, { opacity: 0, y:40, ease: Back.easeOut }, '+=0')
    .from('.sec-5 .box2 .ani3', 0.3, { opacity: 0, y:40, ease: Back.easeOut }, '+=0')
    .from('.sec-5 .box2 .source', 0.4, { opacity: 0, ease: Power2.easeOut }, '+=0')

var secAni5_3 = new TimelineMax({ paused: true});
    secAni5_3
    .from('.sec-5 .box3 .aniTxt', 0.4, { opacity: 0, y:-50, ease: Power2.easeOut }, '+=0.5')
    .from('.sec-5 .box3 .ani1', 0.2, { opacity: 0, ease: Power2.easeOut }, '+=0')
    .from('.sec-5 .box3 .ani2', 0.2, { opacity: 0, y:30, ease: Back.easeOut }, '+=0')
    .from('.sec-5 .box3 .ani3', 0.2, { opacity: 0, y:30, ease: Back.easeOut }, '-=0.1')
    .from('.sec-5 .box3 .ani4', 0.2, { opacity: 0, y:30, ease: Back.easeOut }, '-=0.1')
    .from('.sec-5 .box3 .ani5', 0.2, { opacity: 0, y:30, ease: Back.easeOut }, '-=0.1')
    .from('.sec-5 .box3 .ani6', 0.2, { opacity: 0, y:30, ease: Back.easeOut }, '-=0.1')
    .from('.sec-5 .box3 .ani7', 0.2, { opacity: 0, y:30, ease: Back.easeOut }, '-=0.1')
    .from('.sec-5 .box3 .ani8', 0.2, { opacity: 0, y:30, ease: Back.easeOut }, '-=0.1')
    .from('.sec-5 .box3 .ani9', 0.2, { opacity: 0, y:30, ease: Back.easeOut }, '-=0.1')
    .from('.sec-5 .box3 .ani10', 0.2, { opacity: 0, y:30, ease: Back.easeOut }, '-=0.1')
    .from('.sec-5 .box3 .ani11', 0.2, { opacity: 0, y:30, ease: Back.easeOut }, '-=0.1')
    .from('.sec-5 .box3 .source', 0.4, { opacity: 0, ease: Power2.easeOut }, '+=0')

var secAni5_4 = new TimelineMax({ paused: true});
    secAni5_4
    .from('.sec-5 .box4 .aniTxt', 0.4, { opacity: 0, y:-50, ease: Power2.easeOut }, '+=0.5')
    .from('.sec-5 .box4 .chart2 .ani2', 0.4, { opacity: 0, y:-50, ease: Back.easeOut }, '+=0')
    .from('.sec-5 .box4 .chart2 .ani3', 0.4, { opacity: 0, y:50, ease: Back.easeOut }, '+=0')
    .from('.sec-5 .box4 .chart2 .source', 0.4, { opacity: 0, ease: Power2.easeOut }, '+=0')


/*==================================================*\
        Main Function
\*==================================================*/
const PAGE_HEADER_ACTIVE = 'menuOpen';
let $header;
let $hamburger;
let $headerNav;
const loader = $(".loader");

// $(function () {

  

// });

function mainFunc() {
  $header = $('.page-header');
  $hamburger = $('.hamburger');
  $headerNav = $('.header-nav._mb');

  const tabSwiper1 = new Swiper('.sec-1 .contentBox',{
    autoHeight: true,
    navigation: {
      nextEl: ".sec-1 .swiper-button-next",
      prevEl: ".sec-1 .swiper-button-prev",
    },
    on: {
      realIndexChange: function () {
        const currentSlide = tabSwiper1.realIndex + 1;

        $('.sec-1 .tag' + currentSlide).siblings().removeClass('active');
        $('.sec-1 .tag' + currentSlide).addClass('active')

        switch (currentSlide) {
          case 1: {
            secAni1_1.play(0);
            break; 
          }
          case 2: {
            secAni1_2.play(0);
            break;
          }
        }

      },
    },
    
  });
  const tabSwiper2 = new Swiper('.sec-2 .contentBox',{
    autoHeight: true,
    navigation: {
      nextEl: ".sec-2 .swiper-button-next",
      prevEl: ".sec-2 .swiper-button-prev",
    },
    on: {
      realIndexChange: function () {
        const currentSlide = tabSwiper2.realIndex + 1;

        $('.sec-2 .tag' + currentSlide).siblings().removeClass('active');
        $('.sec-2 .tag' + currentSlide).addClass('active')

        switch (currentSlide) {
          case 1: {
            secAni2_1.play(0);
            break; 
          }
          case 2: {
            secAni2_2.play(0);
            break;
          }
        }
      },
    },
  });
  const tabSwiper3 = new Swiper('.sec-3 .contentBox',{
    autoHeight: true,
    navigation: {
      nextEl: ".sec-3 .swiper-button-next",
      prevEl: ".sec-3 .swiper-button-prev",
    },
    on: {
      realIndexChange: function () {
        const currentSlide = tabSwiper3.realIndex + 1;

        $('.sec-3 .tag' + currentSlide).siblings().removeClass('active');
        $('.sec-3 .tag' + currentSlide).addClass('active')

        switch (currentSlide) {
          case 1: {
            secAni3_1.play(0);
            break; 
          }
          case 2: {
            secAni3_2.play(0);
            break;
          }
        }
      },
    },
  });

  const swiper5 = new Swiper(".sec-5 .contentBox", {
    autoHeight: true,
    navigation: {
      nextEl: ".sec-5 .swiper-button-next",
      prevEl: ".sec-5 .swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    on: {
      realIndexChange: function () {
        const currentSlide = swiper5.realIndex + 1;

        if(winW >=960){
          switch (currentSlide) {
            case 1: {
              secAni5_1.play(0);
              break; 
            }
            case 2: {
              secAni5_2.play(0);
              break;
            }
            case 3: {
              secAni5_3.play(0);
              break;
            }
          }
        }else{
          switch (currentSlide) {
            case 1: {
              secAni5_1.play(0);
              break; 
            }
            case 2: {
              secAni5_4.play(0);
              break;
            }
            case 3: {
              secAni5_2.play(0);
              break;
            }
            case 4: {
              secAni5_3.play(0);
              break;
            }
          }
        }

      },
    },
  });
  
  $('.sec-1 .tag').on('click', function() {
    tabSwiper1.slideTo($(this).data('slide-index'))
  })

  $('.sec-2 .tag').on('click', function() {
    tabSwiper2.slideTo($(this).data('slide-index'))
  })

  $('.sec-3 .tag').on('click', function() {
    tabSwiper3.slideTo($(this).data('slide-index'))
  })

  /* window 事件: Resize & scroll */
  windowEvents();

  /***** Header *****/
  // Hamburger
  $hamburger.on('click', function(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    $header.toggleClass(PAGE_HEADER_ACTIVE);

    if ($header.hasClass(PAGE_HEADER_ACTIVE)) {
      $headerNav.css({'opacity': '1', 'pointer-events': 'all'});
    } else {
      $headerNav.css({'opacity': '0', 'pointer-events': 'none'});
    }
  });

  $doc.on('click', () => {
    if ($header.hasClass(PAGE_HEADER_ACTIVE)) {
      $headerNav.css({'opacity': '0', 'pointer-events': 'none'});
      $header.removeClass(PAGE_HEADER_ACTIVE);
    }
  });

  $('#goTop').click(function () {
    $('html,body').stop().animate({
        scrollTop: 0
    }, 'slow');
    return false;
  });

  // Navigation
  $('.header-nav a').on('click', function(evt) {
    evt.preventDefault();

    const linkIdx = $(this).parent().index() + 1;
    $('html, body').stop().animate({
      scrollTop: sectionPos[linkIdx] - headerTotalH + 20
    }, DURATION.NOR);
  });

  $('.tag').on('click', function() {
    $(this).siblings().removeClass('active');
    $(this).addClass('active');
  });

  /* 收掉 .page-loading */
  // transitionThenRemove({
  //   dom: $(".page-loading"),
  //   duration: DURATION.STD,
  //   callback: () => {
  //     console.log("%cBuild Completed!", logSafeStyle);
  //   }
  // });
}

/*==================================================*\
        window Events
\*==================================================*/
let isFirstTime = true;
let sectionPos;
let sectionHeight;
let footerTop;
let footerPos;
let headerTopH;
let headerNavH;
let headerTotalH;
function windowEvents() {
  // Window Resize
  $win.on("resize", _resize).resize();
  // Window Scroll
  $win.on("scroll", _scroll).scroll();
}

/*========== Window Resize ==========*/
function _resize() {
  getSize();

  winW > 768 ? resizePC() : resizeMB();

  winW >= 960 ? $('.box4').removeClass('swiper-slide') : $('.box4').addClass('swiper-slide');

  footerPos = $('.page-footer .info').offset().top;
  getSectionPos();
}

function getSize() {
  winW = $win.outerWidth();
  winH = $win.height();
  footerTop = $('.page-footer').offset().top;
  headerTopH = $('.header-top').height();
  headerNavH = $('.header-nav._pc').height();
}

function resizePC() {
  // headerInit('flex');
  $('.main-container').css({ marginTop: headerTopH });
  headerTotalH = headerTopH + headerNavH;
  $('.box4').removeClass('swiper-slide');
  $('.box4').removeClass('swiper-slide-next');
  $('.box4').removeClass('swiper-slide-prev');
  
}
function resizeMB() {
  // headerInit('none');
  $('.main-container').css({ marginTop: headerTopH });
  headerTotalH = headerTopH;
  $('.box4').addClass('swiper-slide');
  $('.box4').addClass('swiper-slide-next');
}

function headerInit(display) {
  $header.removeClass(PAGE_HEADER_ACTIVE);
  $headerNav.css({ display });
}

function getSectionPos() {
  sectionPos = [];
  sectionHeight = [];

  $.each($('.anchor'), (idx, el) => {
    sectionPos.push(Math.floor($(el).offset().top));
  });

  $.each($('.sec'), (idx, el) => {
    sectionHeight.push(Math.floor($(el).outerHeight()));
  });
}



/*========== Window Scroll ==========*/
let nowPos;
function _scroll() {
  var winTop = $(window).scrollTop();

  getPos();
  setNavigationHint();

  if (winTop >= 500) {
    $('#goTop').css('opacity', '1');
  } else {
    $('#goTop').css('opacity', '0');
  }

}

function getPos() {
  nowPos = {
    x: $doc.scrollLeft(),
    y: $doc.scrollTop(),
    top: $doc.scrollTop() + headerTotalH + 1
  };

  // if (nowPos.top >= sectionPos[1] - 200) {
  //   $('.fixedBtns').css({'opacity': '1', 'pointer-events': 'all'});
  // }else{
  //   $('.fixedBtns').css({'opacity': '0', 'pointer-events': 'none'});
  // }

  if (nowPos.top > sectionPos[1]) {
    $('.header-nav._pc').addClass('sticky');
  } else {
    $('.header-nav._pc').removeClass('sticky');
  }

  if (nowPos.top >= sectionPos[1] - (winH/3)  && nowPos.top <= sectionPos[2] - (sectionHeight[0]/3)) {
    secAni1_1.play();
    // console.log('sec1');
    return false;
  }
  if (nowPos.top >= sectionPos[2] - (winH/3)  && nowPos.top <= sectionPos[3] - (sectionHeight[1]/3)) {
    secAni2_1.play();
    // console.log('sec2');
    return false;
  }
  if (nowPos.top >= sectionPos[3] - (winH/3)  && nowPos.top <= sectionPos[4] - (sectionHeight[2]/3)) {
    secAni3_1.play();
    // console.log('sec3');
      return false;
  }
  if (nowPos.top >= sectionPos[4] - (winH/3)  && nowPos.top <= sectionPos[5] - (sectionHeight[3]/3)) {
    secAni4.play();
    // console.log('sec4');
      return false;
  }
  if (nowPos.top >= sectionPos[5] - (winH/3)  && nowPos.top <= footerTop - (sectionHeight[4]/3)) {
    secAni5_1.play();
    // console.log('sec5');
      return false;
  }

}

function setNavigationHint() {
  const $navLi = $('.header-nav._pc li');
  const NAV_HINT_CLASS = 'active';

  $.each(sectionPos, (idx, val) => {
    if ((idx === 0 && nowPos.top < sectionPos[1]) || nowPos.top >= footerPos) {
      $navLi.removeClass(NAV_HINT_CLASS);
      return false;
    }

    if (nowPos.top >= val) {
      $navLi.removeClass(NAV_HINT_CLASS);
      $navLi.eq(idx - 1).addClass(NAV_HINT_CLASS);
    }
  });
}

if (device.desktop()) {
  particlesJS("particles-js", {
    "particles": {
      "number": {
        "value": 100,
        "density": {
          "enable": true,
          "value_area": 789.1476416322727
        }
      },
      "color": {
        "value": "#0f7ca4"
      },
      "shape": {
        "type": "circle",
        "stroke": {
          "width": 0,
          "color": "#000000"
        },
        "polygon": {
          "nb_sides": 5
        }
      },
      "opacity": {
        "value": 1,
        "random": false,
        "anim": {
          "enable": true,
          "speed": 0.2,
          "opacity_min": 0,
          "sync": false
        }
      },
      "size": {
        "value": 3,
        "random": true,
        "anim": {
          "enable": true,
          "speed": 2,
          "size_min": 0,
          "sync": false
        }
      },
      "line_linked": {
        "enable": false,
        "distance": 150,
        "color": "#ffffff",
        "opacity": 0.4,
        "width": 1
      },
      "move": {
        "enable": true,
        "speed": 0.8,
        "direction": "none",
        "random": true,
        "straight": false,
        "out_mode": "out",
        "bounce": false,
        "attract": {
          "enable": false,
          "rotateX": 600,
          "rotateY": 1200
        }
      }
    },
    "interactivity": {
      "detect_on": "canvas",
      "events": {
        "onhover": {
          "enable": true,
          "mode": "bubble"
        },
        "onclick": {
          "enable": true,
          "mode": "push"
        },
        "resize": true
      },
      "modes": {
        "grab": {
          "distance": 1400,
          "line_linked": {
            "opacity": 1
          }
        },
        "bubble": {
          "distance": 83.91608391608392,
          "size": 1,
          "duration": 3,
          "opacity": 1,
          "speed": 3
        },
        "repulse": {
          "distance": 200,
          "duration": 0.4
        },
        "push": {
          "particles_nb": 4
        },
        "remove": {
          "particles_nb": 2
        }
      }
    },
    "retina_detect": true
  });
}


